import { render } from "./UserColumns.vue?vue&type=template&id=59365991&scoped=true&ts=true&lang=pug"
import script from "./UserColumns.vue?vue&type=script&lang=ts"
export * from "./UserColumns.vue?vue&type=script&lang=ts"

import "./UserColumns.vue?vue&type=style&index=0&id=59365991&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59365991"]])

export default __exports__